import { ISocialSignUpProvider } from '~domain/entities/Config';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { TranslationRepository } from '~repositories/TranslationRepository';
import { UserRepository } from '~repositories/UserRepository';
import { getSocialSignUpProviderSource } from '~utils/SocialUtils';

interface IProfileErrorPageViewController {
    configRepository: ConfigRepository;
    userRepository: UserRepository;
    translationRepository: TranslationRepository;
}

export class ProfileErrorPageViewController {
    private userRepository: UserRepository;
    private configRepository: ConfigRepository;
    private translationRepository: TranslationRepository;

    constructor({
        userRepository,
        configRepository,
        translationRepository
    }: IProfileErrorPageViewController) {
        this.userRepository = userRepository;
        this.configRepository = configRepository;
        this.translationRepository = translationRepository;
    }

    public get data() {
        const providerSource = getSocialSignUpProviderSource();
        const provider =
            providerSource && this.configRepository.getSocialSignUpProvider(providerSource);

        const {
            profileError: { ctaLabelKey, instructionLabelKey }
        } = provider as ISocialSignUpProvider;

        const { translations } = this.translationRepository;

        return {
            errorMessage: this.userRepository.socialSignUpProfileErrorMessage,
            ctaLabel: ctaLabelKey ? translations[ctaLabelKey] : '',
            instructionLabel: instructionLabelKey ? translations[instructionLabelKey] : ''
        };
    }
}
